module.exports = __webpack_public_path__ + "media/components/country-flag/static/is-1d3679820476094cd24cbb2f1a4a0207.svg";